import script from "./udfSection.vue?vue&type=script&setup=true&lang=js"
export * from "./udfSection.vue?vue&type=script&setup=true&lang=js"

import "./udfSection.vue?vue&type=style&index=0&id=2df1bee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2df1bee0"]])

export default __exports__